import api from "../../request";
import { decrypt } from "../../utils/enkripsi";
import { showLog } from "../../utils/log";
import { onHitung, refreshCharges } from "../../utils/onHitung";
import {
  SET_GET_DATA_PRODUK,
  SET_GET_PAKET,
  SET_KATEGORY,
  SET_KERANJANG,
  SET_LIST_KATEGORI,
  SET_ORDER,
  SET_SHIFT,
} from "../constants/prepareConstants";

export const getKategory = () => async (dispatch) => {
  showLog("PrepareActions Masuk getKategory");
  try {
    const result = await api.apiPrepare.kategory({
      from_origin: "*",
      search1: "",
      on_pos: 1,
    });
    const data = result?.data;
    const kat = data.map((item) => ({
      label: item.id,
      id: item.id,
      order: item.description,
    }));
    let x = [];
    for (const i of kat) {
      if (i.id !== "ADD ON") {
        x.unshift(i);
      }
    }
    x.unshift({
      label: "Promo Diskon",
      id: "Promo Buy X Free Y %",
    });
    x.unshift({
      label: "Promo Paket",
      id: "promo_paket",
    });
    x.unshift({
      label: "Promo",
      id: "promo",
      details: [
        {
          label: "Promo Buy X Free Y",
          id: "promo_buy_x_free_y",
        },
        {
          label: "Promo Paket",
          id: "promo_paket",
        },
      ],
    });
    // x.unshift({
    //   label: "All Kategory",
    //   id: "all",
    // });
    let numericOrders = [];
    let stringOrders = [];
    let missingOrders = [];
    let promoItem = null;
    x.forEach((item) => {
      if (item.id === "promo") {
        promoItem = item;
      } else if ("order" in item) {
        if (!isNaN(parseInt(item.order))) {
          numericOrders.push(item);
        } else {
          stringOrders.push(item);
        }
      } else {
        missingOrders.push(item);
      }
    });
    let maxOrder =
      numericOrders.length > 0
        ? Math.max(...numericOrders.map((item) => parseInt(item.order)))
        : 0;
    missingOrders.forEach((item) => {
      maxOrder += 1;
      item.order = maxOrder.toString();
      numericOrders.push(item);
    });
    numericOrders.sort((a, b) => parseInt(b.order) - parseInt(a.order));
    stringOrders.sort((a, b) => b.order.localeCompare(a.order));
    x = [...numericOrders, ...stringOrders];
    if (promoItem) x.push(promoItem);
    x[2]["selection"] = true;
    dispatch({ type: SET_KATEGORY, value: x });
    dispatch({ type: SET_LIST_KATEGORI, value: x });
  } catch (error) {
    showLog(`Prepare Actions ${error}`);
  }
};

export const setOrder = (value) => async (dispatch) => {
  showLog("PrepareActions Masuk setOrder");
  const orderDate = JSON.parse(localStorage.getItem("orderDate"));
  const dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
  const login = JSON.parse(localStorage.getItem("login"));
  let tex = {};
  let local_charges = refreshCharges();
  for (const item of local_charges) {
    tex["label"] = item.id;
    tex["percent_value"] = item.percent_value;
  }
  try {
    let tlp = "";
    if (value) {
      tlp = value;
    } else {
      if (login) {
        tlp = login.telp;
      } else if (orderDate) {
        tlp = orderDate.nomerHp;
      }
    }
    const res = await api.apiPrepare.getOrder({
      noTelp: "",
      id: dataBranch?.detailData,
    });
    dispatch({
      type: "SET_LOOK_DATA",
      value: res,
    });
    let getStatus = res.data.filter((x) => x["product_id"] !== "QR");
    getStatus.sort((a, b) => new Date(b.trans_date) - new Date(a.trans_date));
    const s = onHitung(getStatus);
    let array = [];
    let si_id = "";
    let total = [];
    total.push({
      label: "Subtotal",
      value: s.data.sub_total,
    });
    for (const xi of s.chargeNotes) {
      total.push({
        label: xi.id + " " + xi.percent_value + "%",
        value: xi.value,
      });
    }
    total.push({
      label: "Total",
      value: s.data.grand_total_net,
    });
    for (const item of getStatus) {
      let data = [];
      for (const temps of getStatus) {
        if (item.si_id == temps.si_id) {
          data.push(temps);
        }
      }
      if (si_id !== item.si_id) {
        si_id = item.si_id;
        array.push({
          id: item.si_id,
          si_id: item.si_id,
          date: item.trans_date,
          data: data,
          trans_status: item.trans_status,
          is_prepared: item.is_prepared,
          prepared_by: item.prepared_by,
          loading: false,
          is_accepted_rejected: item.is_accepted_rejected,
          // subTotal: s.data.sub_total,
          chagerNote: total,
        });
      }
    }
    dispatch({
      type: SET_ORDER,
      value: {
        data: array,
        dataOrder: getStatus,
        loading: false,
      },
    });
  } catch (error) {
    showLog(`Prepare Actions ${error}`);
  }
};

export const produkActions =
  (value = {}) =>
  async (dispatch) => {
    showLog("PrepareActions Masuk produkActions");
    const result = await api.apiPrepare.kategory({
      from_origin: "*",
      search1: "",
      on_pos: 1,
    });
    const dataCategory = result?.data;
    const kat = dataCategory.map((item) => ({
      label: item.id,
      id: item.id,
      order: item.description,
    }));
    let x = [];
    for (const i of kat) {
      if (i.id !== "ADD ON") {
        x.unshift(i);
      }
    }
    x.unshift({
      label: "Promo Diskon",
      id: "Promo Buy X Free Y %",
    });
    x.unshift({
      label: "Promo Paket",
      id: "promo_paket",
    });
    x.unshift({
      label: "Promo",
      id: "promo",
      details: [
        {
          label: "Promo Buy X Free Y",
          id: "promo_buy_x_free_y",
        },
        {
          label: "Promo Paket",
          id: "promo_paket",
        },
      ],
    });
    // x.unshift({
    //   label: "All Kategory",
    //   id: "all",
    // });
    let numericOrders = [];
    let stringOrders = [];
    let missingOrders = [];
    let promoItem = null;
    x.forEach((item) => {
      if (item.id === "promo") {
        promoItem = item;
      } else if ("order" in item) {
        if (!isNaN(parseInt(item.order))) {
          numericOrders.push(item);
        } else {
          stringOrders.push(item);
        }
      } else {
        missingOrders.push(item);
      }
    });
    let maxOrder =
      numericOrders.length > 0
        ? Math.max(...numericOrders.map((item) => parseInt(item.order)))
        : 0;
    missingOrders.forEach((item) => {
      maxOrder += 1;
      item.order = maxOrder.toString();
      numericOrders.push(item);
    });
    numericOrders.sort((a, b) => parseInt(b.order) - parseInt(a.order));
    stringOrders.sort((a, b) => b.order.localeCompare(a.order));
    x = [...numericOrders, ...stringOrders];
    if (promoItem) x.push(promoItem);
    x[2]["selection"] = true;
    const selectedItem = x.find((item) => item.selection === true);
    const selectedId = selectedItem ? selectedItem.id : null;
    const {
      currentPage = 0,
      category_id = selectedId,
      data = [],
      total_baris,
    } = value;
    let baris = 0;
    try {
      const result = await api.apiPrepare.produk({
        search1: "",
        pageSize: "10",
        currentPage: currentPage.toString(),
        category_id: category_id,
        on_pos: 1,
      });
      const response = result?.data;
      if (!total_baris) {
        baris = result.total_baris;
      } else {
        baris = total_baris;
      }
      dispatch({
        type: SET_GET_DATA_PRODUK,
        value: {
          data: data.concat(response),
          currentPage,
          category_id,
          total_baris: baris,
          loading: false,
        },
      });
    } catch (error) {
      showLog(`Prepare Actions ${error}`);
    }
  };

export const paketActions =
  (value = {}) =>
  async (dispatch) => {
    showLog("PrepareActions Masuk paketActions");
    const {
      currentPage = 0,
      category_id = "Promo Paket",
      data = [],
      total_baris,
    } = value;
    let baris = 0;
    try {
      const result = await api.apiPrepare.getPaket({
        from_origin: "*",
        userServer: "cooluruz",
        tgl_awal: "2022-6-21 00:00:00",
        tgl_akhir: "2022-6-21 23:59:59",
        category_id: category_id.toString(),
        filter:
          '{"search1":"","search_col1":"all","search2":"","search_col2":"","search3":"","search_col3":"","sort_col1":"m.updated_date","sort_dir1":"desc","sort_col2":"m.name","sort_dir2":"asc","sort_col3":"m.description","sort_dir3":"asc","jumlah_baris":50,"total_baris":12,"halaman":0,"kolom_tanggal":"none","showUpdated":false}',
      });
      const response = result?.data;
      if (!total_baris) {
        baris = result.total_baris;
      } else {
        baris = total_baris;
      }
      dispatch({
        type: SET_GET_PAKET,
        value: {
          data: data.concat(response),
          currentPage,
          category_id,
          total_baris: baris,
          loading: false,
        },
      });
    } catch (error) {
      showLog(`Prepare Actions ${error}`);
    }
  };

export const shiftActions = () => async (dispatch) => {
  showLog("PrepareActions Masuk shiftActions");
  try {
    const shift = await api.apiPrepare.getShift();
    let data = {};
    const time = shift["data"];
    if (time) {
      if (time.length !== 0) {
        data["min"] = time.min.substring(0, time.min.lastIndexOf(":"));
        data["max"] = time.max.substring(0, time.max.lastIndexOf(":"));
      }
    }
    dispatch({ type: SET_SHIFT, value: data });
  } catch (error) {
    showLog(`Prepare Actions ${error}`);
  }
};

export const setKeranjang = () => async (dispatch) => {
  showLog("PrepareActions Masuk setKeranjang");
  let pesanan = decrypt(JSON.parse(localStorage.getItem("pesanan")));
  let x = 0;
  if (pesanan) {
    for (const i of pesanan) {
      x += Number(i.item);
    }
  }
  dispatch({ type: SET_KERANJANG, value: x });
};

export const SetKategori = (value) => async (dispatch) => {
  showLog("PrepareActions Masuk SetKategori");
  dispatch({ type: SET_KATEGORY, value: value });
};
